// @ts-ignore
import React from "react";

import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { useLocalizedHref } from "@/libraries/web-framework";
import { Row } from "@/libraries/wpl/foundations/src";
import { AtlasLogoBrand } from "@/libraries/wpl/foundations/src/logos/atlas-logo-brand";
import { ConfluenceLogoBrand } from "@/libraries/wpl/foundations/src/logos/confluence-logo-brand";
import { TrelloLogoBrand } from "@/libraries/wpl/foundations/src/logos/trello-logo-brand";
import {
    TryPageCard,
    TryPageHeader
} from "@/templates/try/try-page/components";

import { messages } from "../messages";

const sectionCss = css({
    padding: "32px 0",
    position: "relative",
    verticalAlign: "baseline",
    marginInlineEnd: "auto",
    marginInlineStart: "auto",
    minWidth: "100%"
});

const CollaborateSection = () => {
    const intl = useIntl();

    const tryCloud = intl.formatMessage(messages.tryCloud);
    const collaborateTitle = intl.formatMessage({
        id: "TryPageTemplate.collaborate.title",
        defaultMessage: "Collaborate"
    });
    const confluenceBody = intl.formatMessage({
        id: "TryPageTemplate.collaborate.confluenceBody",
        defaultMessage:
            "Get things done instead of hunting things down. Organize your work, create documents, and discuss everything in one place."
    });

    const trelloBody = intl.formatMessage({
        id: "TryPageTemplate.collaborate.trelloBody",
        defaultMessage:
            "Collaborate and get more done. Trello boards enable your team to organize projects in a fun, flexible, and visual way."
    });

    const atlasBody = intl.formatMessage({
        id: "TryPageTemplate.collaborate.atlasBody",
        defaultMessage:
            "Stay in sync, async by connecting the dots across teams, their apps, and work–wherever it happens."
    });

    return (
        <UFOSegment css={sectionCss} name={"collaborateCards"}>
            <Row>
                <TryPageHeader
                    headerText={collaborateTitle}
                    dividerColor={"#0052cc"}
                />
            </Row>
            <Row layout="6-6">
                <TryPageCard
                    logo={<ConfluenceLogoBrand />}
                    link={useLocalizedHref("/software/confluence/free")}
                    bodyText={confluenceBody}
                    ctaText={tryCloud}
                />
                <TryPageCard
                    logo={<TrelloLogoBrand />}
                    link={"https://www.trello.com/signup"}
                    bodyText={trelloBody}
                    ctaText={tryCloud}
                />
            </Row>
            <div />
            <Row layout="6-6">
                <TryPageCard
                    logo={<AtlasLogoBrand />}
                    link={useLocalizedHref("/try/cloud/signup?bundle=atlas")}
                    bodyText={atlasBody}
                    ctaText={tryCloud}
                />
                <div />
            </Row>
        </UFOSegment>
    );
};

export default CollaborateSection;
